<template>
    <div>
        <div class="top_unit_comment">
            <div class="top_name_box position_relate">
              <div class="mgb_10" style="display: flex;justify-content: space-between;">
                {{brandStoreName}}
                <div class="check_btn_right_csv" style="display: flex;justify-content: space-between;">
                  <div v-if="!isStoreManager" style="padding: 8px 8px 8px 0px;">
                    アラート通知
                    <input type="checkbox" name="checkbox02" :id="upperTitle" v-model="data.reportCommentAlert.cookCheck.isAlert" :value="1">
                    <label class="checkbox02" :for="upperTitle"></label>
                  </div>
                  <div>
                    <div class="btn_all_topButton_csv">
                      <a href="#" @click.prevent.stop="allCsvExport()">全帳票一括CSV出力</a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isStaffRegistered">
                  責任者：
                  <select id="historyFilter" :value="staffId" @change="onChange">
                      <option v-for="staff in data.staffList" :key="staff['id']" :value="staff['id']">{{staff['staffName']}}</option>
                  </select>
              </div>
              <p v-if="!isStaffRegistered">責任者：{{managerName}}</p>
            </div>
            <div class="top_center_box pt-4">
                <p v-if="upperTitle !== ''" class="tex_s">{{upperTitle}}</p>
                <p v-if="lowerTitle !== ''" class="tex_l">{{lowerTitle}}</p>
            </div>
            <div v-if="errorText || validationErrorText">
                <Message :validationMessage="alertMessage" />
            </div>
            <div class="textarea_unit wd876 mgt_15">
                <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{errorText}}</p>
                <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{alertMessage}}</p>
            </div>
            <div v-if="!isLoading" class="textarea_unit wd876 mgt_15">
                <p class="textarea_name">店舗管理者<span class="mgl_20">最終確認日時 {{storeManagerCommentDatetime}} </span></p>
                <textarea v-model="data.cookCheck.comment.storeManager.comment"  :disabled="!isStoreManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                <p v-if="isStoreManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
            </div>
            <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                <p class="textarea_name">企業管理者<span class="mgl_20">最終確認日時 {{companyManagerCommentDatetime}} </span>
                  <span v-if="data.cookCheck.comment.companyManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                  <span v-if="data.cookCheck.comment.companyManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.cookCheck.comment.companyManager.staffName}}</span>
                </p>
                <textarea v-model="data.cookCheck.comment.companyManager.comment" :disabled="!isCompanyManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                <p v-if="isCompanyManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
            </div>
            <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                <p class="textarea_name">その他管理者<span class="mgl_20">最終確認日時 {{otherManagerCommentDatetime}} </span>
                  <span v-if="data.cookCheck.comment.otherManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                  <span v-if="data.cookCheck.comment.otherManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.cookCheck.comment.otherManager.staffName}}</span>
                </p>
                <textarea v-model="data.cookCheck.comment.otherManager.comment" :disabled="!isOtherManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                <p v-if="isOtherManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
            </div>
        </div>
        <div v-for="(group, groupIndex) in data.cookCheck.buttonList" :key="groupIndex" class="wd876 chohyo_unit">
            <div class="chohyo_tbl_unit tbl_bg_blue mgt_15">
                <table>
                    <tbody>
                        <tr>
                            <th :colspan="group.header.col+4" class="chohyo_index" :class="tableHeaderColor(group.no)">{{group.upperButtonName}}：{{group.lowerButtonName}}</th>
                            <div class="check_btn_right_csv">
                                <div class="btn_csv">
                                    <a href="#" @click.prevent.stop="csvExport(group.no)">CSV出力</a>
                                </div>
                            </div>
                        </tr>
                        <tr v-for="(headers, index) in group.header.list"
                            :key="index">
                            <th v-show="index === 0" :rowspan="group.header.row" class="tbl_tex_center_pd3 text_white_space widthTab">品名/調理名</th>
                            <th v-show="index === 0" :rowspan="group.header.row"  class="wd50 tbl_tex_center_pd3 text_white_space">確認者</th>
                            <th v-show="index === 0" :rowspan="group.header.row"  class="wd50 tbl_tex_center_pd3 text_white_space">実施時刻</th>
                            <th
                                    class="tbl_tex_center_pd3 wd50"
                                    v-for="header in headers"
                                    :key="header.id"
                                    :rowspan="hasChild(header) ? 1 : group.header.row - index"
                                    :colspan="hasChild(header) ? header.children : 1"
                                    :class="hasChildren(header) ? 'wd50 text_white_space' : 'wd50 text_white_space'"
                            >{{header.lowerButtonName}}
                            </th>
                        </tr>
                    </tbody>
                    <tbody v-for="history in group.historyList" :key="history.id">
                        <tr>
                            <td class="tbl_tex_left_pd5 wd50 text_word-break text_white_space"><span v-show="history.remeasureFlg" class="text-warning">（再）</span>{{history.cookingName}}</td>

                            <td class="tbl_tex_left_pd5 text-wrap wd50 text_white_space">
                                {{history.staffName}}
                            </td>
                            <td class="tbl_tex_center_pd3 wd50 text_white_space">{{history.checkTime}}</td>
                            <td v-for="item in history.itemList" :key="item.id" :class="cellClass(item)" class="tbl_tex_center_pd3 text_white_space wd50">
                                <p v-if="isTypeCheck(item)" :class="checkIconClass(item)">
                                    <i v-if="(item.status === 1 || item.status === 4) && item.value === '1'" class="fas fa-check fa-xs wd50"></i>
                                    <i v-else-if="item.type === 4  && item.status === 1 && item.value !== '1'" class="fas fa-exclamation wd50"></i>
                                    <i v-else-if="item.type === 4  && item.status === 4 && item.value === '0'" class="fas fa-exclamation wd50"></i>
                                </p>
                                <p v-else-if="item.type === 1" class="text_word-break wd50">{{item.value}}
                                </p>
                                <p v-else-if="item.type === 5 && item.temperatureLimitFlg === 1 && item.manualFlg === 0" class="text_white_space wd50 temperature_limit_bg_color">{{item.value}}
                                <p v-else-if="item.type === 5 && item.temperatureLimitFlg === 1 && item.manualFlg === 1" class="text_white_space wd50 temperature_limit_manual_bg_color">{{item.value}}
                                <p v-else-if="item.type === 5 && item.temperatureLimitFlg === 0 && item.manualFlg === 1" class="text_white_space wd50 manual_bg_color">{{item.value}}
                                <p v-else class="text_white_space wd50">{{item.value}}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <th class="tbl_tex_center_pd3 text_white_space">改善措置／コメント</th>
                            <td class="texbox_td_comment tbl_tex_left_pd5 text-wrap" :colspan="group.header.col+2">{{history.comment}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isCsvLoading">
            <pulse-loader class="w-100 text-center" :loading="isCsvLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CookCheckReport',
        props: {
            data: {
                type: Object,
                required: true,
            },
            upperTitle: {
                type: String
            },
            lowerTitle: {
                type: String
            },
            errorText: {
                type: String
            },
            validationErrorText: {
                type: String
            },
            isLoading: {
                type: Boolean
            },
            selectDate:{
                type: String
            },
            staffId: {
                type: Number
            }
        },
        data: function () {
            return {
                storeManagerComment: "",
                companyManagerComment: "",
                otherManagerComment: "",
                showContent: false,
                isCsvLoading:false,
                addFormFlg:true,
                alertMessage:"",
                storeManagerCommentDatetime: '',
                companyManagerCommentDatetime: '',
                otherManagerCommentDatetime: '',
            }
        },
        created() {
            this.storeManagerComment = this.data.cookCheck.comment.storeManager.comment;
            this.companyManagerComment = this.data.cookCheck.comment.companyManager.comment
            this.otherManagerComment = this.data.cookCheck.comment.otherManager.comment
            this.lastUpdateTimeStore()
            this.lastUpdateTimeCompany()
            this.lastUpdateTimeOther()
        },
        computed: {
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            role: function () {
                return Number(this.$store.getters['manager/manager'].authorityKbn)
            },
            isStoreManager: function () {
                return this.role === 4
            },
            isCompanyManager: function () {
                return this.role === 2
            },
            isOtherManager: function () {
                return this.role === 6
            },
            brandStoreName: function () {
                let brandName = this.$store.getters['brand/name']
                let storeName = this.$store.getters['store/name']

                if (brandName == null) {
                    brandName = ''
                }

                if (storeName == null) {
                    storeName = ''
                }

                return brandName + '・' + storeName
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            isStaffRegistered: function () {
                if(this.role === 4 && this.data.staffList != null){
                    return true
                }
                return false
            },
        },
        methods: {
            cellClass: function (item) {
                if (item.status === 2) {
                    return 'bg_td_grey'
                }
                if (item.status === 3) {
                    return  'bg_td_black'
                }

                if (item.type === 4 && item.value !== '1' && item.status === 1) {
                    return 'tbl_bg_red'
                }
                return ''
            },
            checkIconClass: function (item) {
                if (this.isTypeCheck(item) && item.value === '1') {
                    return 'icn_blue_td'
                }
                return ''
            },
            isTypeCheck: function (item) {
                return item.type === 4 || item.type === 6
            },
            hasChild: function (header) {
                return header.children > 0
            },
            hasChildren: function (header) {
                return header.children > 1
            },
            tableHeaderColor: function (no) {
                const color = [
                    'chori_bg01',
                    'chori_bg02',
                    'chori_bg03',
                ]
                if (no === 1 || no === 2) {
                    return color[no-1]
                }
                return color[2]
            },
            checkComent(){

                // コメントの差分をチェックする
                if(this.storeManagerComment !== this.data.cookCheck.comment.storeManager.comment ||
                    this.companyManagerComment !== this.data.cookCheck.comment.companyManager.comment ||
                    this.otherManagerComment !== this.data.cookCheck.comment.otherManager.comment){

                    // 親のコメントフラグを書き換える
                    this.$parent.commentFlg = true;
                }
                else{
                    this.$parent.commentFlg = false;
                }
            },
            async csvExport(buttonNo){

                this.addFormFlg = true;
                this.isCsvLoading = true;
                this.alertMessage = "";

                var params = {
                    start_date: this.selectDate,end_date:this.selectDate
                };

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];

                // API呼び出し
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/cooking/'  + buttonNo,{params})
                    .then(response => (this.csvResponseData = response))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        this.addFormFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if (err.customError.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                            if(error.code == 400){
                                this.alertMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isCsvLoading = false);

                if(this.addFormFlg){
                    // CSV出力
                    if(!this.commonDownloadCSV(this.csvResponseData)){
                        this.alertMessage =  "CSVの出力に失敗しました。";
                        this.addFormFlg = false;
                        this.scrollTop();
                    }
                    else{
                        this.showContent = true;
                    }
                }
            },
            closeModel(){
                this.showContent = false;
            },
            scrollTop() {
                window.scrollTo(0, 0);
            },
            formatLastUpdateTime: function (lastUpdateTime) {
                lastUpdateTime = lastUpdateTime.replace(/-/g, '/')
                lastUpdateTime = lastUpdateTime.slice( 0, -3 )
                return lastUpdateTime
            },
            lastUpdateTimeStore: function () {
                if(this.data.cookCheck.comment.storeManager.commentsDatetime != "") {
                    this.storeManagerCommentDatetime = this.formatLastUpdateTime(this.data.cookCheck.comment.storeManager.commentsDatetime)
                } else {
                    this.storeManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeCompany: function () {
                if(this.data.cookCheck.comment.companyManager.commentsDatetime != "") {
                    this.companyManagerCommentDatetime = this.formatLastUpdateTime(this.data.cookCheck.comment.companyManager.commentsDatetime)
                } else {
                    this.companyManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeOther: function () {
                if(this.data.cookCheck.comment.otherManager.commentsDatetime != "") {
                    this.otherManagerCommentDatetime = this.formatLastUpdateTime(this.data.cookCheck.comment.otherManager.commentsDatetime)
                } else {
                    this.otherManagerCommentDatetime = '-'
                }
            },
            updateUserCommentDatetime(){
                if (this.isStoreManager) {
                    this.lastUpdateTimeStore()
                } else if (this.isCompanyManager) {
                    this.lastUpdateTimeCompany()
                } else {
                    this.lastUpdateTimeOther()
                }
            },
            async allCsvExport(){
              this.addFormFlg = true;
              this.isCsvLoading = true;
              this.alertMessage = "";
              var params = {
                date: this.selectDate
              };
              var brandId = this.$store.getters['brand/id'];
              var storeId = this.$store.getters['store/id'];
              var dailyReportCsvResponseData = null;
              var cookingReportCsvResponseData = null;
              var healthCheckReportCsvResponseData = null;
              // API呼び出し
              // 店舗チェック一括CSV
              await this.$axios
                  .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allDaily',{params})
                  .then(response => {
                    dailyReportCsvResponseData = response
                    // 調理チェック一括CSV
                    return this.$axios
                        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allCooking' ,{params})
                  })
                  .then(response => {
                    cookingReportCsvResponseData = response
                    // 健康身だしなみチェックCSV
                    params = {
                      start_date: this.selectDate,end_date:this.selectDate
                    };
                    return this.$axios
                        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allHealth' ,{params})
                  })
                  .then(response => (healthCheckReportCsvResponseData = response))
                  .catch((err) => {
                    let error = {
                      button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                      }}
                    this.addFormFlg = false;
                    if (err.customError) {
                      error = Object.assign(error, err.customError);
                      if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                      }
                      if(error.code == 400){
                        this.alertMessage =  error.message;
                        this.scrollTop();
                      }
                    }
                    if(error.code !== 400){
                      this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                  }).finally(()=> this.isCsvLoading = false);
              if(this.addFormFlg){
                // CSV出力
                if(!this.commonDownloadCSV(dailyReportCsvResponseData) || !this.commonDownloadCSV(cookingReportCsvResponseData) || !this.commonDownloadCSV(healthCheckReportCsvResponseData)){
                  this.alertMessage =  "CSVの出力に失敗しました。";
                  this.addFormFlg = false;
                  this.scrollTop();
                }
                else{
                  this.showContent = true;
                }
              }
            },
            onChange(event) {
                const newValue = Number(event.target.value);
                this.$emit('update-staff-id', newValue);
            }
        }
    }
</script>
